export default __webpack_public_path__ + "static/media/overview.a62ecdcc.jpg";